import React, { useEffect, useState } from "react"

import { graphql } from "gatsby"
import { ArticleKeyFigureRowV2FieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./key-figure-row-v2.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"
import KeyFigureV2 from "./key-figure-v2/key-figure-v2"
import ArrowSvg from "../../../../../../static/vectors/arrowV2.svg"
import BackArrowSvg from "../../../../../../static/vectors/backArrowV2.svg"

type KeyFigureRowV2Props = {
  data: ArticleKeyFigureRowV2FieldsFragment
}

const KeyFigureRowV2: React.FC<KeyFigureRowV2Props> = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.transformContainer)[0], 400)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  const handlePrevSlide = () => {
    setCurrentSlide(prev => 
      prev === 0 ? data.keyFigureElementV2.length - 1 : prev - 1
    )
  }

  const handleNextSlide = () => {
    setCurrentSlide(prev => 
      prev === data.keyFigureElementV2.length - 1 ? 0 : prev + 1
    )
  }

  return (
    <section className={styles.container}>
      <div className={styles.transformContainer}>
        {data.keyFigureElementV2.map((keyFigure, index) => (
          <KeyFigureV2 
            key={keyFigure.id} 
            data={keyFigure} 
            keyFigureAmount={data.keyFigureElementV2.length}
            isVisible={index === currentSlide}
          />
        ))}
        <div className={styles.carouselButtons}>
          <button 
            className={styles.prevButton}
            onClick={handlePrevSlide}
          aria-label="Previous slide"
          >
            <img src={BackArrowSvg} className={styles.arrow} alt="Previous" />
          </button>
          <button 
            className={styles.nextButton}
            onClick={handleNextSlide}
            aria-label="Next slide"
          >
            <img src={ArrowSvg} className={styles.arrow} alt="Next" />
          </button>
        </div>
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment ArticleKeyFigureRowV2Fields on DatoCmsArticleKeyFigureRowV2 {
    __typename
    id
    keyFigureElementV2 {
      ...KeyFigureV2Fields
    }
  }
`

export default KeyFigureRowV2
